// The newsroom's tabs and contacts, shared by the pages, their social cards and
// their Markdown.

export const newsroomTabs = [
  { id: "releases", label: "Press Releases", to: "/news", ogSlug: "news-releases" },
  { id: "articles", label: "In the News", to: "/news/articles", ogSlug: "news-articles" },
  { id: "podcasts", label: "On Podcasts", to: "/news/podcasts", ogSlug: "news-podcasts" },
] as const

export type NewsroomCategory = (typeof newsroomTabs)[number]["id"]

export const newsroomContacts = [
  {
    id: "press",
    label: "Press inquiries",
    href: "mailto:media@entire.io",
    text: "media@entire.io",
  },
  {
    id: "support",
    label: "Non-media inquiries",
    href: "mailto:support@entire.io",
    text: "support@entire.io",
  },
  {
    id: "assets",
    label: "Media assets",
    href: "/downloads/entire-brand-kit.zip",
    text: "Download brand kit",
  },
] as const

export const newsroomDescriptions: Record<NewsroomCategory, string> = {
  releases: "The latest announcements and press releases from Entire.",
  articles: "Press coverage and articles about Entire.",
  podcasts: "Podcast conversations featuring Entire and Entirons, the people building it.",
}
